export default function Footer() {
  const socialLinks = [
    {
      name: "텔레그램 공식채널",
      icon: "ri-telegram-fill",
      bg: "bg-[#229ED9]",
      href: "https://t.me/worldcuptv_official",
      label: "실시간 공지 및 중계 일정 안내",
    },
    {
      name: "카카오톡 오픈채팅",
      icon: "ri-kakao-talk-fill",
      bg: "bg-[#FEE500]",
      textColor: "text-[#3C1E1E]",
      href: "https://open.kakao.com/o/worldcuptv",
      label: "커뮤니티 소통 채널",
    },
    {
      name: "유튜브",
      icon: "ri-youtube-fill",
      bg: "bg-[#FF0000]",
      href: "https://youtube.com/@worldcuptv",
      label: "하이라이트 & 분석 영상",
    },
    {
      name: "인스타그램",
      icon: "ri-instagram-fill",
      bg: "bg-gradient-to-br from-[#F58529] via-[#DD2A7B] to-[#8134AF]",
      href: "https://instagram.com/worldcuptv_official",
      label: "경기 소식 & 비하인드",
    },
  ];

  return (
    <footer className="w-full bg-[#20262e] mt-6">
      <div className="px-4 md:px-6 py-5 md:py-6">
        <div className="max-w-[1460px] mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
            <div className="col-span-2 md:col-span-3 lg:col-span-1">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-xl font-bold tracking-tight">
                  <span className="text-primary-500">월드컵</span>
                  <span className="text-white/80">티비 시즌2</span>
                </span>
                <span className="text-[10px] px-1.5 py-0.5 rounded bg-primary-500 text-foreground-50 font-bold whitespace-nowrap">
                  공식 커뮤니티
                </span>
              </div>
              <p className="text-xs text-white/60 leading-relaxed">
                월드컵티비 시즌2는 스포츠 중계 &amp; 커뮤니티 플랫폼입니다.
                <br />
                실시간 중계, 경기 일정, 전문 분석, 먹튀검증 및 커뮤니티 서비스를 제공합니다.
                <br />
                공식 홈페이지: wdctv24.com
              </p>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-white/80 mb-2">이용안내</h4>
              <ul className="space-y-1">
                <li>
                  <a className="text-xs text-white/50 hover:text-white transition-colors" href="/guide">
                    이용 가이드
                  </a>
                </li>
                <li>
                  <a className="text-xs text-white/50 hover:text-white transition-colors" href="/faq">
                    자주 묻는 질문
                  </a>
                </li>
                <li>
                  <a className="text-xs text-white/50 hover:text-white transition-colors" href="/notices">
                    공지사항
                  </a>
                </li>
                <li>
                  <a className="text-xs text-white/50 hover:text-white transition-colors" href="/support/inquiry">
                    고객센터
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-white/80 mb-2">핵심 서비스</h4>
              <ul className="space-y-1">
                <li>
                  <a className="text-xs text-white/50 hover:text-white transition-colors" href="/live">
                    실시간 중계
                  </a>
                </li>
                <li>
                  <a className="text-xs text-white/50 hover:text-white transition-colors" href="/schedule">
                    경기 일정
                  </a>
                </li>
                <li>
                  <a className="text-xs text-white/50 hover:text-white transition-colors" href="/analysis">
                    스포츠 분석
                  </a>
                </li>
                <li>
                  <a className="text-xs text-white/50 hover:text-white transition-colors" href="/verified">
                    보증업체
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-white/80 mb-2">정보센터</h4>
              <ul className="space-y-1">
                <li>
                  <a className="text-xs text-white/50 hover:text-white transition-colors" href="/support/terms">
                    정책 및 운영원칙
                  </a>
                </li>
                <li>
                  <a className="text-xs text-white/50 hover:text-white transition-colors" href="/faq">
                    FAQ
                  </a>
                </li>
                <li>
                  <a className="text-xs text-white/50 hover:text-white transition-colors" href="/about">
                    사이트 소개
                  </a>
                </li>
                <li>
                  <a className="text-xs text-white/50 hover:text-white transition-colors" href="/support/inquiry">
                    광고/제휴 문의
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-white/80 mb-2">공식 채널</h4>
              <div className="flex flex-wrap gap-1.5">
                {socialLinks.map((link) => (
                  <a
                    key={link.name}
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`w-9 h-9 rounded-full ${link.bg} ${link.textColor || 'text-white'} flex items-center justify-center hover:opacity-80 transition-opacity`}
                    title={link.name}
                  >
                    <i className={`${link.icon} text-base`} />
                  </a>
                ))}
              </div>
              <div className="flex flex-col gap-0.5 mt-1.5">
                {socialLinks.map((link) => (
                  <span key={link.name} className="text-[10px] text-white/30">
                    {link.name}: {link.label}
                  </span>
                ))}
              </div>
            </div>
            <div className="col-span-2 md:col-span-1">
              <h4 className="text-sm font-semibold text-white/80 mb-2">보안 & 안전</h4>
              <div className="flex items-start gap-3">
                <ul className="space-y-1.5 flex-1">
                  <li className="flex items-center gap-1.5">
                    <span className="w-3.5 h-3.5 rounded-full bg-green-500/15 flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-[10px] text-green-500" />
                    </span>
                    <span className="text-xs text-white/50">SSL 보안 인증 완료</span>
                  </li>
                  <li className="flex items-center gap-1.5">
                    <span className="w-3.5 h-3.5 rounded-full bg-green-500/15 flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-[10px] text-green-500" />
                    </span>
                    <span className="text-xs text-white/50">개인정보 보호 정책 준수</span>
                  </li>
                  <li className="flex items-center gap-1.5">
                    <span className="w-3.5 h-3.5 rounded-full bg-green-500/15 flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-[10px] text-green-500" />
                    </span>
                    <span className="text-xs text-white/50">24시간 모니터링 시스템 운영</span>
                  </li>
                </ul>
                <div className="relative w-16 h-16 flex-shrink-0 hidden sm:block animate-float-subtle">
                  <div className="absolute inset-0 rounded-full bg-primary-500/10 blur-md animate-pulse-glow" />
                  <div className="absolute inset-0 rounded-full bg-gradient-to-br from-background-800 via-background-900 to-background-950 opacity-90" />
                  <div className="absolute inset-0 rounded-full border border-primary-500/20 animate-pulse-ring" />
                  <div className="absolute inset-1 rounded-full bg-gradient-to-br from-background-700/15 to-background-950/50 border border-background-800/50" />
                  <div className="relative z-10 w-full h-full flex items-center justify-center">
                    <i className="ri-shield-keyhole-fill text-2xl text-primary-400" />
                  </div>
                  <div className="absolute bottom-1 right-1 w-3 h-3 rounded-full bg-primary-500 animate-pulse-dot" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t border-background-900">
        <div className="max-w-[1460px] mx-auto px-4 md:px-6 py-2.5">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-1">
            <p className="text-[10px] text-white/20 text-center sm:text-left">
              COPYRIGHT &copy; 월드컵티비 시즌2. ALL RIGHTS RESERVED.
            </p>
            <div className="flex items-center gap-2">
              <a className="text-[10px] text-white/20 hover:text-white/60 transition-colors" href="/support/terms">
                이용약관
              </a>
              <span className="text-white/15">|</span>
              <a className="text-[10px] text-white/20 hover:text-white/60 transition-colors" href="/support/privacy">
                개인정보처리방침
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}